import { FC, memo, useCallback } from 'react'
import Dropzone from 'react-dropzone'

import { Button } from 'ui/components/Buttons'

import { UploadButtonProps } from './UploadButtonProps'

export const UploadButton: FC<UploadButtonProps> = memo((props) => {
  const { onUpload } = props

  const onUploadWrapper = useCallback((acceptedFiles) => onUpload(acceptedFiles), [onUpload])

  return (
    <Dropzone onDrop={onUploadWrapper} multiple={true}>
      {({ getRootProps, getInputProps }) => (
        <Button face="tertiary" onClick={onUploadWrapper} {...getRootProps()}>
          Upload
          <input {...getInputProps()} />
        </Button>
      )}
    </Dropzone>
  )
})
